import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import IndexSectionNavigations13 from "../components/navigations/IndexSectionNavigations13";
import ContactSectionContacts from "../components/contacts/ContactSectionContacts";
import IndexSectionFooters7 from "../components/footers/IndexSectionFooters7";

const meta = {
  title: "",
  meta: [],
  link: [],
  style: [],
  script: [],
};

export default function Contact() {
  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet {...meta}></Helmet>
      </HelmetProvider>
      <IndexSectionNavigations13 />
      <ContactSectionContacts />
      <IndexSectionFooters7 />
    </React.Fragment>
  );
}
